import { render, staticRenderFns } from "./Headcount.vue?vue&type=template&id=b745e3f0&"
import script from "./Headcount.vue?vue&type=script&lang=js&"
export * from "./Headcount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports